import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonElafronApostrofosKentimata';
const args = {};

export class OligonElafronApostrofosKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
